import { Stack } from '@mui/material';
import * as R from 'ramda';
import { SimplePrice } from '../../products-details-v2/types/productDetails.types';
import useProductPricesRenderer from '../useProductPricesRenderer';
import RetailPriceSection from './components/RetailPriceSection';
import WholesalePriceSection from './components/WholesalePriceSection';

interface ProductPricesRendererV3Props {
  prices: SimplePrice[];
  wholesalePriceDisabled?: boolean;
  retailPriceDisabled?: boolean;
}

const ProductPricesRendererV3 = ({
  prices,
  retailPriceDisabled,
  wholesalePriceDisabled,
}: ProductPricesRendererV3Props) => {
  const { markup, showMarkup, showRetailPrice, showInfoTooltip, pricesConfig } =
    useProductPricesRenderer({
      prices,
      hasOrderItemQuantity: false,
      showAllPrices: true,
    });

  const hasRetailPriceVariation = pricesConfig?.minRetailPrice !== pricesConfig?.maxRetailPrice;
  const shouldShowRetailPriceSection =
    showRetailPrice && !retailPriceDisabled && !R.isNil(pricesConfig.minRetailPrice);

  if (!prices) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={{ xs: 2, lg: 3 }}>
      {!wholesalePriceDisabled && (
        <WholesalePriceSection
          minMaxWholesale={{
            min: pricesConfig.minWholesalePrice,
            max: pricesConfig.maxWholesalePrice,
          }}
          prices={prices}
          showInfoTooltip={showInfoTooltip}
        />
      )}
      {shouldShowRetailPriceSection && (
        <RetailPriceSection
          hasRetailPriceVariation={hasRetailPriceVariation}
          markup={markup}
          minMaxRetailPrice={{ min: pricesConfig.minRetailPrice, max: pricesConfig.maxRetailPrice }}
          showMarkup={showMarkup}
        />
      )}
    </Stack>
  );
};

export default ProductPricesRendererV3;
